import { IconBuilding, IconBuildingSkyscraper } from '@tabler/icons-react';
import {
  RadioCard,
  RadioGroup,
  RadioGroupProps,
} from '@zorro/design-system/v2/Radio';
import { YesNo } from '@zorro/types';
import { Grid } from '@zorro/web/design-system';
import { ForwardedRef, forwardRef } from 'react';
import { ControllerRenderProps, Path } from 'react-hook-form';

type AleFieldValues = { isApplicableLargeEmployer?: YesNo | null };
type Props<T extends AleFieldValues, U extends Path<T>> = Omit<
  ControllerRenderProps<T, U>,
  'ref'
> & {
  radioGroupProps?: Omit<RadioGroupProps, 'children'>;
  isReadOnly?: boolean;
};

export const ApplicableLargeEmployerInput = forwardRef(
  <T extends AleFieldValues, U extends Path<T>>(
    { radioGroupProps, isReadOnly = false, disabled, ...field }: Props<T, U>,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <RadioGroup
        {...field}
        {...radioGroupProps}
        ref={ref}
        w="100%"
        label="Is the company considered an Applicable Large Employer (ALE)?"
        isReadOnly={isReadOnly}
      >
        <Grid align="center">
          {isReadOnly ? (
            field.value === YesNo.NO ? (
              <Grid.Col span={{ sm: 6 }}>
                <RadioCard
                  value={YesNo.NO}
                  iconColor="red"
                  icon={<IconBuildingSkyscraper />}
                  label="No, it's not an ALE"
                  disabled={disabled}
                  isReadOnly={isReadOnly}
                />
              </Grid.Col>
            ) : (
              <Grid.Col span={{ sm: 6 }}>
                <RadioCard
                  value={YesNo.YES}
                  iconColor="yellow"
                  icon={<IconBuilding />}
                  label="Yes, it's an ALE"
                  disabled={disabled}
                  isReadOnly={isReadOnly}
                />
              </Grid.Col>
            )
          ) : (
            <>
              <Grid.Col span={{ sm: 6 }}>
                <RadioCard
                  value={YesNo.YES}
                  iconColor="yellow"
                  icon={<IconBuilding />}
                  label="Yes, it's an ALE"
                  disabled={disabled}
                  isReadOnly={isReadOnly}
                />
              </Grid.Col>
              <Grid.Col span={{ sm: 6 }}>
                <RadioCard
                  value={YesNo.NO}
                  iconColor="red"
                  icon={<IconBuildingSkyscraper />}
                  label="No, it's not an ALE"
                  disabled={disabled}
                  isReadOnly={isReadOnly}
                />
              </Grid.Col>
            </>
          )}
        </Grid>
      </RadioGroup>
    );
  }
);

ApplicableLargeEmployerInput.displayName = 'ApplicableLargeEmployerInput';
